module.exports = __webpack_public_path__ + "static/media/media-img.f26909e4.png";